// Extract the `exp` claim (seconds) from a JWT and return it as ms-since-epoch.
// Returns null if the token can't be parsed — callers should treat that as
// "expires immediately" so they re-fetch via refresh.
export function decodeJwtExpiryMs(token: string): number | null {
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(b64)) as { exp?: number };
    return typeof payload.exp === "number" ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}
